import { useMemo } from 'react';

import { LOCAL_STORAGE_KEY } from '@common/constants';

type useQueryStringParametersReturn = {
    searchParameters: URLSearchParams;
    loadEstimateCode: string | undefined;
    locationExternalId: string | undefined;
    locationCheckoutUrl: string | undefined;
    userToken: string | undefined;
};

export const useQueryStringParameters = (): useQueryStringParametersReturn => {
    const searchParameters = useMemo(() => {
        const locationUrl = new URL(location.href);
        return locationUrl.searchParams;
    }, [location.href]);

    const loadEstimateCode = useMemo(() => {
        return searchParameters.get(LOCAL_STORAGE_KEY.LOAD_ESTIMATE) ?? undefined;
    }, [searchParameters]);

    const locationExternalId = useMemo(
        () => searchParameters.get(LOCAL_STORAGE_KEY.EXTERNAL_ID) ?? undefined,
        [searchParameters]
    );
    const locationCheckoutUrl = useMemo(
        () => searchParameters.get(LOCAL_STORAGE_KEY.CHECKOUT_URL) ?? undefined,
        [searchParameters]
    );

    const userToken = useMemo(
        () => searchParameters.get(LOCAL_STORAGE_KEY.USER_TOKEN) ?? undefined,
        [searchParameters]
    );

    return {
        searchParameters,
        loadEstimateCode,
        locationCheckoutUrl,
        locationExternalId,
        userToken,
    };
};
